import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LoginGate from "@/components/LoginGate";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import NewOrder from "@/pages/NewOrder";
import Orders from "@/pages/Orders";
import OrderDetail from "@/pages/OrderDetail";
import CompletedOrders from "@/pages/CompletedOrders";
import Quotes from "@/pages/Quotes";
import QuoteDetail from "@/pages/QuoteDetail";
import Costs from "@/pages/Costs";
import Tasks from "@/pages/Tasks";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <LoginGate>
        <Layout>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/zlecenia/nowe" element={<NewOrder />} />
            <Route path="/zlecenia" element={<Orders />} />
            <Route path="/zlecenia/:id" element={<OrderDetail />} />
            <Route path="/zakonczone" element={<CompletedOrders />} />
            <Route path="/wyceny" element={<Quotes />} />
            <Route path="/wyceny/:id" element={<QuoteDetail />} />
            <Route path="/koszty" element={<Costs />} />
            <Route path="/zadania" element={<Tasks />} />
          </Routes>
        </Layout>
        </LoginGate>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
